import { Country } from "@shared/services/country/types/country.type";
import { ProjectAddress, ProjectBaseData, ProjectDetails } from "./project-details.type";
import { RegionDto } from "@core/types/common.types";

export interface ProjectDetailsFormAddress extends Pick<ProjectAddress, "zipCode" | "city"> {
  streets: string[];
  country: Country | null;
  region: RegionDto | null;
}
export interface ProjectDetailsFormBaseData extends Pick<ProjectBaseData, "buildingOwner" | "costCenterNumber" | "costCenterRegion" | "shortName"> {
  emails: string[];
}
export interface ProjectDetailsForm extends Pick<ProjectDetails, "number" | "name" | "image" | "status"> {
  plannedStart: Date | null;
  plannedEnd: Date | null;
  address: ProjectDetailsFormAddress;
  baseData: ProjectDetailsFormBaseData;
}
export function parseToProjectDetailsForm (value: ProjectDetails): ProjectDetailsForm {
  return {
    status: value.status,
    number: value.number,
    name: value.name,
    image: value.image,
    plannedEnd: value.plannedEnd,
    plannedStart: value.plannedStart,
    baseData: {
      ...value.baseData,
      emails: value.baseData.emails ?? []
    },
    address: {
      ...value.address,
      streets: [ value.address.streetOne, ...value.address.streetTwo ? [ value.address.streetTwo ] : [] ],
      region: value.address.region ?? null
    }

  };
}
export function parseProjectDetailsFromForm (patch: ProjectDetailsForm): ProjectDetails {
  const streets: string[] = patch.address.streets;
  // eslint-disable-next-line @tseslint/no-non-null-assertion
  const streetOne: string = streets[ 0 ]!;
  const streetTwo: string | undefined = streets[ 1 ] ?? undefined;
  const emails: string[] | undefined = patch.baseData.emails.filter((email: string) => email !== "");

  return {
    status: patch.status,
    number: patch.number,
    name: patch.name,
    image: patch.image,
    // eslint-disable-next-line @tseslint/no-non-null-assertion
    plannedStart: patch.plannedStart!,
    // eslint-disable-next-line @tseslint/no-non-null-assertion
    plannedEnd: patch.plannedEnd!,
    baseData: {
      buildingOwner: patch.baseData.buildingOwner,
      costCenterNumber: patch.baseData.costCenterNumber,
      costCenterRegion: patch.baseData.costCenterRegion,
      shortName: patch.baseData.shortName,
      emails: emails.length > 0 ? emails : undefined
    },
    address: {
      streetOne,
      streetTwo,
      zipCode: patch.address.zipCode,
      city: patch.address.city,
      // eslint-disable-next-line @tseslint/no-non-null-assertion
      country: patch.address.country!,
      region: patch.address.region ?? undefined
    }
  };
}
